<template>
  <div class="container">
    <template v-if="style == 0">
      <Header-top>
        <div class="title">
          <div class="title_name">
            <svg
              t="1576458346227"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3838"
              width="16"
              height="16"
            >
              <path
                d="M891.454218 85.444021 131.835607 85.444021c-36.555567 0-66.294892 29.739325-66.294892 66.293869l0 548.614919c0 36.555567 29.739325 66.292845 66.294892 66.292845l313.515437 0 0 120.618125L342.840322 887.263779c-13.30605 0-24.092721 10.786671-24.092721 24.092721 0 13.30605 10.786671 24.092721 24.092721 24.092721l337.608158 0c13.307074 0 24.094768-10.786671 24.094768-24.092721 0-13.30605-10.786671-24.092721-24.094768-24.092721L577.939805 887.263779 577.939805 766.644631l313.514413 0c36.554544 0 66.293869-29.737278 66.293869-66.292845L957.748087 151.736866C957.748087 115.182322 928.008762 85.444021 891.454218 85.444021L891.454218 85.444021zM131.835607 133.629463l759.618611 0c9.984399 0 18.107403 8.123005 18.107403 18.108426l0 440.119903L113.727181 591.857792 113.727181 151.736866C113.727181 141.752468 121.851209 133.629463 131.835607 133.629463L131.835607 133.629463zM529.753339 887.263779l-36.216853 0L493.536486 766.644631l36.216853 0L529.753339 887.263779 529.753339 887.263779zM891.454218 718.459189 131.835607 718.459189c-9.984399 0-18.108426-8.123005-18.108426-18.10638l0-60.308551 795.83444 0 0 60.308551C909.561621 710.336184 901.438617 718.459189 891.454218 718.459189L891.454218 718.459189z"
                p-id="3839"
                fill="#1a92ed"
              />
            </svg>
            <span>{{ userShopName }}</span>
          </div>
          <div class="title_signin">
            <i style="color: #909399; margin-right: 3px;" class="el-icon-tickets"></i>
            <!-- <svg
            t="1576220549848"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="7010"
            width="12"
            height="12"
          >
            <path
              d="M740.75 894h-461a62.07 62.07 0 0 1-62-62V202a62.07 62.07 0 0 1 62-62h461a62.07 62.07 0 0 1 62 62v630a62.07 62.07 0 0 1-62 62z m-461-730a38 38 0 0 0-38 38v630a38 38 0 0 0 38 38h461a38 38 0 0 0 38-38V202a38 38 0 0 0-38-38z"
              p-id="7011"
              fill="#1a92ed"
            />
            <path
              d="M682 383H342a12 12 0 0 1 0-24h340a12 12 0 0 1 0 24zM682 517H342a12 12 0 0 1 0-24h340a12 12 0 0 1 0 24zM682 651H342a12 12 0 0 1 0-24h340a12 12 0 0 1 0 24z"
              p-id="7012"
              fill="#1a92ed"
            />
            </svg>-->
            <span
              style="color: #909399; cursor: pointer;"
              @click="$root.jump('/pc/orderdetail', urlQueryName)"
            >订单详情</span>

            <div class="merchant_parent">
              <span @click="isShowMerchant.info= !isShowMerchant.info">
                <!-- <i style="color: #1a92ed;" class="el-icon-user-solid"></i> -->
                <!-- <svg
                t="1576220347414"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6150"
                width="12"
                height="12"
              >
                <path
                  d="M830.976 976 201.6 976c-52.928 0-96-43.072-96-96l0-212.032c0-17.664 14.336-32 32-32s32 14.336 32 32l0 212.032c0 17.6 14.336 32 32 32l629.376 0c17.6 0 32-14.4 32-32l0-212.032c0-17.664 14.336-32 32-32s32 14.336 32 32l0 212.032C926.976 932.928 883.968 976 830.976 976zM966.016 419.968c-0.192-1.152 0.064-2.304-0.256-3.456l-0.64-2.304c-0.256-0.96-0.128-1.6-0.384-2.624-0.128-0.512-0.512-0.896-0.704-1.408l-86.912-323.712c-3.776-13.952-16.384-23.68-30.848-23.68L186.24 62.784c-14.464 0-27.136 9.728-30.912 23.744L68.48 410.176C68.352 410.688 67.968 411.008 67.84 411.52 67.584 412.48 67.712 413.184 67.456 414.08l-0.64 2.432c-0.32 1.152 0 2.304-0.192 3.456C63.68 432.576 61.312 444.608 61.312 455.936c0 92.608 75.392 168 168 168 56.576 0 106.496-28.288 136.896-71.296 33.088 47.488 87.936 78.784 150.08 78.784s116.992-31.296 150.016-78.784c30.528 42.944 80.384 71.296 136.96 71.296 92.608 0 168-75.392 168-168C971.264 444.608 968.896 432.576 966.016 419.968z"
                  p-id="6151"
                  fill="#909399"
                />
                </svg>商家信息-->
                <i style="color: #909399;" class="el-icon-user-solid"></i>
                商家信息
              </span>
              <Merchant-info
                v-show="isShowMerchant.info"
                class="merchant_info"
                :merchantInfo="merchantInfo"
                :info="true"
                :qrcode="false"
              >
                <div slot="content"></div>
              </Merchant-info>
            </div>

            <div class="merchant_parent">
              <span @click="isShowMerchant.qrcode = !isShowMerchant.qrcode">
                <i style="color: #909399;" class="el-icon-mobile"></i>
                手机店铺
              </span>
              <Merchant-info
                v-show="isShowMerchant.qrcode"
                class="merchant_info"
                :merchantInfo="merchantInfo"
                :info="false"
                :qrcode="true"
              >
                <div slot="content"></div>
              </Merchant-info>
            </div>
            <!-- <el-popover
            placement="bottom"
            title="标题"
            width="200"
            trigger="hover"
            content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
          >
            <el-button slot="reference">商家信息</el-button>
            </el-popover>-->
          </div>
        </div>
      </Header-top>
      <Search class="search" @watchItp="watchItp"></Search>
      <!--轮播公告-->
      <div class="leadnews flex-nw-ac" v-if="set_base.notice !== ''">
        <!-- <img :src="set_base.notice_img" /> -->
        <span class="trumpet">
          <svg
            t="1576119141452"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1318"
            width="30"
            height="20"
          >
            <path
              d="M872.802928 755.99406 872.864326 755.99406 872.864326 755.624646Z"
              p-id="1319"
              fill="#1a92ed"
            />
            <path
              d="M744.055658 192.799074c-4.814656-2.889817-9.601682-5.251607-15.442714-5.251607-14.262842 0-25.758664 11.559267-25.758664 25.805736 0 10.285251 6.088672 18.519796 14.6957 23.195282 94.679359 55.247278 158.344355 157.787676 158.344355 275.30416 0 117.424386-63.605643 219.931015-158.159136 275.18034-8.29492 4.538363-15.442714 13.050224-15.442714 23.583115 0 14.261818 11.559267 25.820062 25.791409 25.820062 5.716188 0 10.252505-2.202155 15.22475-5.063319 109.871363-64.133669 183.764304-183.143157 183.764304-319.520197C927.074995 375.785665 853.495186 257.010515 744.055658 192.799074z"
              p-id="1320"
              fill="#1a92ed"
            />
            <path
              d="M773.946432 511.867994c0-79.96524-43.344181-149.739373-107.821681-187.289594-2.920516-1.52268-9.785877-4.520967-14.603603-4.520967-14.325263 0-25.914206 11.589966-25.914206 25.89988 0 9.616008 5.096065 18.176988 12.865006 22.666232 49.839105 28.307719 83.45983 81.829703 83.45983 143.244448 0 62.472843-34.801621 116.817566-86.070284 144.750755-7.457856 4.538363-12.397355 12.803607-12.397355 22.188348 0 14.325263 11.588943 25.943882 25.882484 25.943882 6.090718 0.031722 13.33061-3.542686 13.33061-3.542686C729.048873 664.171772 773.946432 593.294514 773.946432 511.867994z"
              p-id="1321"
              fill="#1a92ed"
            />
            <path
              d="M541.3694 124.672464c-10.846022-5.219885-23.740704-3.790326-33.215496 3.712555-0.435928 0.358157-46.423309 36.914748-97.195669 74.296123-88.308255 65.081251-114.036219 75.925227-119.257128 77.649498l-110.6194 0c-0.63752 0-1.243317 0.062422-1.879813 0.093121l-56.504922 0c-14.231119 0-25.775037 11.543917-25.775037 25.775037l0 411.697573c0 14.261818 11.512195 25.761734 25.775037 25.761734l189.511191 0.027629c5.096065 1.865487 29.395494 13.0799 107.761306 76.999698 45.613874 37.162388 86.505189 73.485665 86.940095 73.829496 5.841032 5.218862 13.298887 7.92039 20.820188 7.92039 4.349051 0 8.729825-0.930185 12.862959-2.764973 11.277858-5.064342 18.517749-16.252149 18.517749-28.619828 0 0 0.031722-97.257068 0.031722-132.212184 0.808412-2.484587 1.213641-5.127787 1.213641-7.863085 0-2.792603-1.245364-578.026786-1.245364-578.026786C559.110459 140.892891 552.214399 129.924071 541.3694 124.672464zM508.308423 726.470653c0 1.494027-0.467651 94.617961-0.467651 94.617961-13.889335-11.745509-29.332049-24.64019-45.240367-37.507242-104.59008-84.702124-130.505309-91.816149-148.030451-91.816149-0.372483 0-0.683569 0.091074-1.025353 0.091074s-0.652869-0.091074-1.025353-0.091074L170.394297 691.765223c-18.037818 0-22.248723-5.128811-22.248723-23.246447L148.145573 352.559685c0-12.32163 1.461281-20.057825 16.298198-20.057825l128.065747 0c17.090237 0 43.315528-6.991228 157.787676-90.839915 20.383236-14.914688 40.330544-29.938869 57.544601-43.113937 0 0 0.373507 445.207781 0.467651 521.368368C507.779374 722.028481 508.308423 724.234729 508.308423 726.470653z"
              p-id="1322"
              fill="#1a92ed"
            />
          </svg>
        </span>
        <div class="flex-nw" id="scrollarea">
          <div class="text">{{set_base.notice}}</div>
          <div class="text" style="margin-left: 0">{{set_base.notice}}</div>
        </div>
      </div>

      <section class="content">
        <nav>
          <ul class="allGoods">
            <li :class="{ nav_ul_active: choosefl === -1 }" @click="selectAllGoods">
              <div class="allGoods_img"></div>
              <span>全部商品</span>
            </li>
          </ul>
          <ul
            class="nav_ul"
            v-for="(item, index) in newCategoryname"
            :key="index"
            @click="classification(item.id, index)"
            :class="{ nav_ul_active: index === choosefl }"
          >
            <li class="nav_li">
              <div>
                <img :src="$root.tomedia(item.thumb)" alt />
              </div>
              <span>{{ item.title }}</span>
            </li>
          </ul>

          <!-- <ul
          v-if="categoryname.length % 4 != 0"
          v-for="(i, index) in 4 - (categoryname.length % 4)"
          :key="index"
        >
          
          </ul>-->
        </nav>

        <Shop-list
          :category="category"
          :newGoods="newGoods"
          :set_base="set_base"
          :mobile="merchantInfo.mobile"
          :choosefl="choosefl"
          style="margin: 0 17px;"
        ></Shop-list>

        <section class="footer">技术支持：微涟网自动发货平台</section>
      </section>
    </template>
    <template v-else>
      <header>
        <span>{{userShopName || '微涟网自动发卡平台'}}</span>
        <template>
          <div class="container_Search">
            <div class="left">
              <svg
                t="1574755620026"
                class="icon icon_search"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="11485"
                width="26"
                height="22"
              >
                <path
                  d="M900.266667 900.266667c-8.533333 8.533333-21.333333 8.533333-29.866667 0L740.266667 768c-66.133333 59.733333-153.6 96-249.6 96-206.933333 0-373.333333-166.4-373.333333-373.333333S283.733333 119.466667 490.666667 119.466667s373.333333 166.4 373.333333 373.333333c0 93.866667-36.266667 181.333333-93.866667 245.333333l130.133333 130.133333C908.8 876.8 908.8 891.733333 900.266667 900.266667zM490.666667 162.133333c-183.466667 0-330.666667 147.2-330.666667 330.666667S307.2 823.466667 490.666667 823.466667s330.666667-147.2 330.666667-330.666667S672 162.133333 490.666667 162.133333z"
                  p-id="11486"
                  fill="#8a8a8a"
                />
              </svg>
              <input type="text" v-model="search_ipt" class="search_ipt" placeholder="搜索内容..." />
            </div>
            <div class="right">
              <button @click="searchClick">搜索</button>
            </div>
          </div>
        </template>
        <div>
          <span @click="isShowMerchant.info= !isShowMerchant.info">
            <mu-button flat>商家信息</mu-button>
          </span>
          <div v-if="name" class="login_box">
            <span class="login">{{name}}</span>
            <span class="login_out">
              <mu-button flat @click="loginOut">退出登录</mu-button>
            </span>
          </div>
          <span v-else>
            <mu-button flat @click="loginClick">登录注册</mu-button>
          </span>
          <Merchant-info
            v-show="isShowMerchant.info"
            class="merchant_info"
            :merchantInfo="merchantInfo"
            :info="true"
            :qrcode="false"
          >
            <div slot="content"></div>
          </Merchant-info>
        </div>
      </header>
      <div class="tab">
        <div @click="tabClick(0)" :class="tab == 0 ? 'tab-pitch' : ''">商城主页</div>
        <i></i>
        <div @click="tabClick(1)" :class="tab == 1 ? 'tab-pitch' : ''">订单查询</div>
        <i></i>
        <div @click="tabClick(2)" :class="tab == 2 ? 'tab-pitch' : ''">会员中心</div>
        <i></i>
        <div @click="tabClick(3)" :class="tab == 3 ? 'tab-pitch' : ''">api信息</div>
      </div>
      <div v-if="tab == 0" class="style content-style">
        <div class="goods-tab">
          <div :class="goodsType == 0?'type-pitch': ''" @click="goodsClick(0)">
            <a class="goods-type">全部商品</a>
          </div>
          <div
            v-for="(item,index) in newCategoryname"
            :key="index"
            :class="goodsType == index + 1?'type-pitch': ''"
            @click="goodsClick(index + 1,item)"
          >
            <a class="goods-type">{{item.title}}</a>
          </div>
        </div>
        <ShopList2
          :category="category"
          :mobile="merchantInfo.mobile"
          :categoryId="categoryId"
          :zhanwei="zhanwei"
        ></ShopList2>
      </div>
      <div v-if="tab == 1" class="style1 content-style">
        <div style="padding:20px 10px">
          <mu-container>
            <div>
              <span
                class="tab_order"
                :class="orderActive == null ? 'order-active' : ''"
                @click="tabOrder()"
              >全部</span>
              <span
                class="tab_order"
                :class="orderActive == 0 ? 'order-active' : ''"
                @click="tabOrder(0)"
              >待支付</span>
              <span
                class="tab_order"
                :class="orderActive == 1 ? 'order-active' : ''"
                @click="tabOrder(1)"
              >待充值</span>
              <span
                class="tab_order"
                :class="orderActive == 3 ? 'order-active' : ''"
                @click="tabOrder(3)"
              >已完成</span>
              <span
                class="tab_order"
                :class="orderActive == -1 ? 'order-active' : ''"
                @click="tabOrder(-1)"
              >已关闭</span>
            </div>
            <mu-paper :z-depth="1">
              <mu-data-table height="700" :columns="orderColumns" :data="orderList">
                <template slot-scope="scope">
                  <td>{{scope.row.title}}</td>
                  <td>{{scope.row.ordersn}}</td>
                  <td class="is-center">{{scope.row.price}}</td>
                  <td class="is-center">{{scope.row.num}}</td>
                  <td class="is-center">{{scope.row.type_text}}</td>
                  <td class="is-center">{{scope.row.type}}</td>
                  <td class="is-center">{{scope.row.actual_price}}</td>
                  <td class="is-center">{{scope.row.statusstr}}</td>

                  <td class="is-center">
                    <mu-button flat color="primary" @click="detailsClick(scope.row.id)">订单详情</mu-button>
                  </td>
                </template>
              </mu-data-table>
            </mu-paper>
            <mu-flex justify-content="end">
              <mu-pagination :total="orderTotal" :current.sync="orderCurrent" @change="orderChange"></mu-pagination>
            </mu-flex>
          </mu-container>
        </div>
      </div>
      <div v-if="tab == 2" class="style3 content-style">
        <template v-if="userInfo && userInfo.apply_status == 2">
          <div class="style3-left">
            <dl>
              <dd @click="dlClick(1)" :class="dlState == 1 ? 'dl-active' : ''">商品管理</dd>
              <dd @click="dlClick(2)" :class="dlState == 2 ? 'dl-active' : ''">奖励订单</dd>
              <dd @click="dlClick(3)" :class="dlState == 3 ? 'dl-active' : ''">佣金提现</dd>
              <dd @click="dlClick(4)" :class="dlState == 4 ? 'dl-active' : ''">提现记录</dd>
              <dd @click="dlClick(5)" :class="dlState == 5 ? 'dl-active' : ''">{{managerName}}设置</dd>
              <dd @click="dlClick(6)" :class="dlState == 6 ? 'dl-active' : ''">公告</dd>
            </dl>
          </div>
          <div class="style3-right" v-if="dlState == 1">
            <div class="style3-tab">
              <mu-tabs :value.sync="goodsActive" inverse color="#F04E00" indicator-color="#84B0EC">
                <mu-tab>出售中</mu-tab>
                <mu-tab>已下架</mu-tab>
                <mu-tab>仓库中</mu-tab>
                <mu-button color="primary" v-if="goodsActive == 0" @click="allGoodsOut">一键下架</mu-button>
                <mu-button color="primary" v-else-if="goodsActive == 1" @click="allGoodsDelete">一键删除</mu-button>
                <mu-button
                  color="primary"
                  v-else-if="goodsActive == 2"
                  @click="allGoodsPataway"
                >一键上架</mu-button>
              </mu-tabs>
            </div>
            <div>
              <mu-container v-if="goodsActive == 0 || goodsActive == 1">
                <mu-paper :z-depth="1">
                  <mu-data-table height="600" :columns="goodsColumns" :data="goodsList">
                    <template slot-scope="scope">
                      <td>{{scope.row.goods.title}}</td>
                      <td class="is-center">{{scope.row.goods_price}}</td>
                      <td class="is-center">{{scope.row.profit}}</td>
                      <td class="is-center">
                        <mu-button flat color="primary" @click="goodsEdit(scope.row)">编辑</mu-button>
                        <mu-button
                          flat
                          color="secondary"
                          @click="goodsOperation(scope.row.id)"
                        >{{goodsActive == 0 ? '下架' : goodsActive == 1 ? '上架' : ''}}</mu-button>
                        <mu-button flat color="success" @click="goodsDelete(scope.row.id)">删除</mu-button>
                      </td>
                    </template>
                  </mu-data-table>
                </mu-paper>
              </mu-container>
              <mu-container v-else>
                <mu-paper :z-depth="1">
                  <mu-data-table height="600" :columns="allGoodsColumns" :data="allGoodsList">
                    <template slot-scope="scope">
                      <td>{{scope.row.title}}</td>
                      <td class="is-center">{{scope.row.goods_price}}</td>
                      <td class="is-center">
                        <mu-button
                          flat
                          :disabled="scope.row.memberGoods !== null ? true : false"
                          @click="goodsPataway(scope.row)"
                        >{{scope.row.memberGoods !== null ? '已上架' : '上架'}}</mu-button>
                      </td>
                    </template>
                  </mu-data-table>
                </mu-paper>
              </mu-container>
            </div>
            <mu-dialog width="260" :open.sync="openAllGoods">
              <div style="width:100%;display:flex;justify-content: space-between">
                <mu-button color="primary" @click="dialogTab = 1">默认价格</mu-button>
                <mu-button color="primary" @click="dialogTab = 2">批量修改</mu-button>
              </div>
              <p v-if="dialogTab == 1" style="font-size:14px">温馨提示： 默认价格和主商城商品销售价格相同</p>
              <div v-else>
                <mu-form
                  :model="goodsDialgoForm"
                  class="mu-demo-form"
                  label-position="top"
                  label-width="100"
                >
                  <mu-form-item prop="type" label="操作类型">
                    <mu-radio v-model="goodsDialgoForm.type" label="批量加价" value="default"></mu-radio>
                  </mu-form-item>
                  <mu-form-item prop="menoyType" label="金额类型">
                    <mu-radio v-model="goodsDialgoForm.menoyType" value="fixed" label="固定金额"></mu-radio>
                    <mu-radio v-model="goodsDialgoForm.menoyType" value="percent" label="百分比金额"></mu-radio>
                  </mu-form-item>
                  <mu-form-item prop="input" label="利润修改">
                    <mu-text-field v-model="goodsDialgoForm.input" placeholder="元/百分比"></mu-text-field>
                  </mu-form-item>
                </mu-form>
              </div>
              <mu-button slot="actions" flat color="primary" @click="openAllGoods = false">取消</mu-button>
              <mu-button slot="actions" flat color="primary" @click="goodsDialogSure">确定</mu-button>
            </mu-dialog>
            <mu-dialog width="260" :open.sync="openGoods">
              <p>是否确定{{goodsActive == 0 ? '下架' : goodsActive == 1 ? '上架' : ''}}该商品？</p>
              <div style="width:100%;display:flex;justify-content: space-between">
                <mu-button flat color="primary" @click="openGoods = false">取消</mu-button>
                <mu-button flat color="primary" @click="openGoodsSure">确定</mu-button>
              </div>
            </mu-dialog>
            <mu-dialog width="260" :open.sync="openGoodsDelete">
              <p>是否确定删除该商品？</p>
              <div style="width:100%;display:flex;justify-content: space-between">
                <mu-button flat color="primary" @click="openGoodsDelete = false">取消</mu-button>
                <mu-button flat color="primary" @click="openGoodsDeleteSure">确定</mu-button>
              </div>
            </mu-dialog>
            <mu-dialog width="360" :open.sync="openGoodsEdit">
              <mu-form
                :model="goodsEditForm"
                class="mu-demo-form"
                label-position="left"
                label-width="100"
              >
                <mu-form-item prop="agent_price" label="代理价格">
                  <mu-text-field disabled v-model="goodsEditForm.agent_price"></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="profit" label="利润">
                  <mu-text-field v-model="goodsEditForm.profit"></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="goods_price" label="实际售价">
                  <mu-text-field disabled v-model="goodsEditForm.goods_price"></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="sort" label="排序">
                  <mu-text-field v-model="goodsEditForm.sort"></mu-text-field>
                </mu-form-item>
              </mu-form>
              <div style="width:100%;display:flex;justify-content: space-between">
                <mu-button flat color="primary" @click="openGoodsEdit = false">取消</mu-button>
                <mu-button flat color="primary" @click="openGoodsEditSure">确定</mu-button>
              </div>
            </mu-dialog>
            <mu-dialog width="360" :open.sync="openGoodsStore">
              <mu-form
                :model="goodsEditForm"
                class="mu-demo-form"
                label-position="left"
                label-width="100"
              >
                <mu-form-item prop="agent_price" label="代理价格">
                  <mu-text-field disabled v-model="goodsEditForm.agent_price"></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="profit" label="利润">
                  <mu-text-field v-model="goodsEditForm.profit"></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="goods_price" label="实际售价">
                  <mu-text-field disabled v-model="goodsEditForm.goods_price"></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="sort" label="排序">
                  <mu-text-field v-model="goodsEditForm.sort"></mu-text-field>
                </mu-form-item>
              </mu-form>
              <div style="width:100%;display:flex;justify-content: space-between">
                <mu-button flat color="primary" @click="openGoodsStore = false">取消</mu-button>
                <mu-button flat color="primary" @click="openGoodsStoreSure">确定</mu-button>
              </div>
            </mu-dialog>
          </div>
          <div class="style3-right" v-if="dlState == 2">
            <div>
              <mu-container>
                <mu-paper :z-depth="1">
                  <mu-data-table height="600" :columns="orderAwardColumns" :data="orderAwardList">
                    <template slot-scope="scope">
                      <td>{{scope.row.goods[0].title}}</td>
                      <td class="is-center">{{scope.row.ordersn}}</td>
                      <td class="is-center">{{scope.row.utime}}</td>
                      <td
                        class="is-center"
                      >{{scope.row.group_id == 0 ? '普通订单' : scope.row.group_id > 0 ? '拼团订单' : ''}}</td>
                      <td class="is-center">{{scope.row.order_divide.agent}}</td>
                      <td class="is-center">{{scope.row.order_divide.agent_id == 0 ? '未提现' : '已提现'}}</td>
                    </template>
                  </mu-data-table>
                </mu-paper>
                <mu-flex justify-content="end">
                  <mu-pagination
                    :total="orderAwardTotal"
                    :current.sync="orderAwardPage"
                    @change="orderAwardChange"
                  ></mu-pagination>
                </mu-flex>
              </mu-container>
            </div>
          </div>
          <div class="style3-right" v-if="dlState == 3">
            <div class="echarts">
              <div class="echarts-title">奖励金额：{{withdrawInfo.old_apply_price}}</div>
              <div class="echarts-title">实际可提金额：{{withdrawInfo.apply_price}}</div>
              <div
                style="text-align: center;;margin-top:80px"
              >满一元可提现，提现需支付{{withdrawInfo.withdraw_ratio}}%手续费</div>
              <div class="pay-init">
                <div style="display: flex;align-items: center;">
                  提现方式：
                  <span class="pay-style">支付宝</span>
                </div>
                <div>
                  姓名：
                  <input
                    type="text"
                    v-if="withdrawInput"
                    v-model="withdrawInfo.name"
                    class="withdraw-input"
                  />
                  <span v-else>{{withdrawInfo.name}}</span>
                </div>

                <div>
                  支付宝账号：
                  <input
                    type="text"
                    v-if="withdrawInput2"
                    v-model="withdrawInfo.alipay_no"
                    class="withdraw-input"
                  />
                  <span v-else>{{withdrawInfo.alipay_no}}</span>
                </div>
              </div>
              <mu-button full-width color="primary" @click="postWithdrawInfo">提现</mu-button>
            </div>
          </div>
          <div class="style3-right" v-if="dlState == 4">
            <div class="style3-tab">
              <mu-tabs :value.sync="active1" inverse color="#F04E00" indicator-color="#84B0EC">
                <mu-tab @click="withdrawStatus = 0">审核中</mu-tab>
                <mu-tab @click="withdrawStatus = 1">已提现</mu-tab>
              </mu-tabs>
            </div>
            <div>
              <mu-container>
                <mu-paper :z-depth="1">
                  <mu-data-table height="500" :columns="withdrawColumns" :data="withdrawRecord">
                    <template slot-scope="scope">
                      <td>提现到支付宝</td>
                      <td class="is-center">{{scope.row.ctime}}</td>
                      <td
                        class="is-center"
                      >{{withdrawStatus == 0 ? scope.row.money : withdrawStatus == 1 ? scope.row.paymoney : ''}}</td>
                    </template>
                  </mu-data-table>
                </mu-paper>
                <mu-flex justify-content="end">
                  <mu-pagination
                    :total="withdrawTotal"
                    :current.sync="withdrawPage"
                    @change="withdrawChange"
                  ></mu-pagination>
                </mu-flex>
              </mu-container>
            </div>
          </div>
          <div class="style3-right" v-if="dlState == 5">
            <div style="background:#fff;margin: 10px 10px 20px;padding: 20px;height: 100%;">
              <mu-form
                :model="settingInfo"
                class="mu-demo-form"
                label-position="left"
                label-width="100"
              >
                <mu-form-item prop="custormer" label="客户二维码">
                  <img
                    class="settingInfo-img"
                    v-if="uploadImgStyle"
                    :src="$root.tomedia(settingInfo.custormer)"
                    alt
                  />
                  <img class="settingInfo-img" v-else :src="settingInfo.custormer" alt />
                  <el-upload
                    action
                    :http-request="uploadRequest"
                    :on-change="uploadChange"
                    list-type="picture-card"
                    :show-file-list="false"
                    ref="upload"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </mu-form-item>
                <mu-form-item prop="qq" label="联系QQ">
                  <mu-text-field v-model="settingInfo.qq" placeholder="微信联系不上紧急联系QQ ,不填写不显示"></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="mobile" label="联系手机号">
                  <mu-text-field v-model="settingInfo.mobile" placeholder="微信联系不上紧急联系手机号 ,不填写不显示"></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="close_agent" label="店主入口">
                  <mu-radio v-model="settingInfo.close_agent" value="0" label="开启"></mu-radio>
                  <mu-radio v-model="settingInfo.close_agent" value="1" label="关闭"></mu-radio>
                </mu-form-item>
                <mu-form-item prop="close_notice" label="公告">
                  <mu-radio v-model="settingInfo.close_notice" value="0" label="开启"></mu-radio>
                  <mu-radio v-model="settingInfo.close_notice" value="1" label="关闭"></mu-radio>
                </mu-form-item>
                <mu-form-item prop="close_group" label="拼团活动">
                  <mu-radio v-model="settingInfo.close_group" value="0" label="开启"></mu-radio>
                  <mu-radio v-model="settingInfo.close_group" value="1" label="关闭"></mu-radio>
                </mu-form-item>
              </mu-form>
              <mu-button color="primary" @click="setSetting">保存设置</mu-button>
            </div>
          </div>
          <div class="style3-right" v-if="dlState == 6">
            <div>
              <mu-container>
                <mu-paper :z-depth="1">
                  <mu-data-table height="500" :columns="noticeColumns" :data="noticeList">
                    <template slot="expand" slot-scope="prop">
                      <div style="padding: 24px;" v-html="prop.row.detail"></div>
                    </template>
                    <template slot-scope="scope">
                      <td>{{scope.row.title}}</td>
                      <td class="is-left">{{scope.row.ctime}}</td>
                    </template>
                  </mu-data-table>
                </mu-paper>
              </mu-container>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="back-FFF" style="padding:20px">
            <mu-container v-if="userInfo.apply_status == 0">
              <mu-form ref="form" :model="validateForm" class="mu-demo-form">
                <mu-form-item label="姓名" prop="name">
                  <mu-text-field v-model="validateForm.name" prop="name"></mu-text-field>
                </mu-form-item>
                <mu-form-item label="手机号" prop="mobile">
                  <mu-text-field v-model="validateForm.mobile" prop="mobile"></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="paytype" label="支付方式">
                  <mu-radio v-model="validateForm.paytype" value="0" label="微信支付"></mu-radio>
                  <mu-radio v-model="validateForm.paytype" value="1" label="支付宝支付"></mu-radio>
                </mu-form-item>
                <mu-form-item>
                  <mu-button color="primary" @click="openShopSubmit">缴费</mu-button>
                </mu-form-item>
              </mu-form>
            </mu-container>
            <div v-if="userInfo.apply_status == 1" class="Api-box">
              <img src="@/assets/applying.png" />
              <p>申请成功，正在审核中，请耐心等待...</p>
            </div>
          </div>
          <mu-dialog title="支付扫码" width="360" :open.sync="payDialog">
            <canvas id="payQrcode"></canvas>
            <mu-button slot="actions" flat color="primary" @click="payDialog = false">取消</mu-button>
          </mu-dialog>
        </template>
      </div>
      <div v-if="tab == 3" class="style3 content-style">
        <div class="back-FFF">
          <div v-if="apiInfo.status == 0 || apiInfo.status == 3" class="API-box">
            <img src="@/assets/no-apply.png" />
            <p>您暂时不是会员，马上申请吧</p>
            <mu-button color="primary" @click="applyApi">立即申请</mu-button>
          </div>
          <div v-if="apiInfo.status == 1" class="API-box">
            <img src="@/assets/applying.png" />
            <p>申请成功，正在审核中，请耐心等待...</p>
          </div>
          <div v-if="apiInfo.status == 2" class="API-box">
            <mu-form
              :model="apiInfo"
              class="mu-demo-form"
              label-position="left"
              label-width="100"
              style="width:50%"
            >
              <mu-form-item prop="appid" label="appid">
                <mu-text-field disabled v-model="apiInfo.appid"></mu-text-field>
              </mu-form-item>
              <mu-form-item prop="appkey" label="appkey">
                <mu-text-field disabled v-model="apiInfo.appkey"></mu-text-field>
              </mu-form-item>
              <mu-form-item prop="mobile" label="用户手机号">
                <mu-text-field disabled v-model="apiInfo.mobile"></mu-text-field>
              </mu-form-item>
              <mu-form-item prop="ctime" label="申请时间">
                <mu-text-field disabled v-model="apiInfo.ctime"></mu-text-field>
              </mu-form-item>
              <mu-form-item prop="money" label="账户余额">
                <mu-text-field disabled v-model="apiInfo.money"></mu-text-field>
                <mu-button color="primary" @click="tabOrder()">yue</mu-button>
                <Account-Details :orderList="orderList"></Account-Details>
              </mu-form-item>
              <mu-form-item prop="level" label="用户会员级别">
                <mu-text-field disabled v-model="apiInfo.level"></mu-text-field>
              </mu-form-item>
              <div style="display:flex;justify-content: space-evenly;">
                <div style="width:130px">
                  <mu-button full-width color="primary" @click="copyAppid(apiInfo.appid)">复制appid</mu-button>
                </div>
                <div style="width:130px">
                  <mu-button full-width color="primary" @click="copyAppkey(apiInfo.appkey)">复制appkey</mu-button>
                </div>
              </div>
            </mu-form>
          </div>
          <div v-if="apiInfo.status == 4" class="API-box">
            <p>您的账号已被冻结！</p>
          </div>
        </div>
      </div>
      <div style="margin:20px 0">
        <section class="footer" style="text-align: center;">技术支持：微涟网自动发货平台</section>
      </div>
    </template>
  </div>
</template>

<script>
import HeaderTop from '@/components/Header/Header' // 头部组件
import Search from '@/components/Search/Search' // 搜索组件
import ShopList from '@/components/Shop/ShopList' // 商品组件
import ShopList2 from '@/components/Shop/ShopList2' // 样式二商品组件
import MerchantInfo from '@/components/Merchant/MerchantInfo' // 信息组件
import loading from '@/common/loading' // 引入封装的loading
import getData from '@/utils/getData' // 获取数据接口
import login from '@/utils/login' // 获取数据接口
import { StorageStack } from '@/common/Stack'
import Message from '@/common/Message'
import { getUrlUserInfo, jump, isMobile } from '@/common/common' // 获取url的参数
import Order from '../../../utils/getOrder'
import { loading2 } from '@/common/loading2'

import AccountDetails from '@/components/AccountDetails/AccountDetails' //在api信息获取订单组件
export default {
  name: 'pcIndex',
  data() {
    return {
      style: 1, // 样式
      // 是否登录
      search_ipt: '',
      zhanwei: false,
      tab: 0, // tab开关
      dlState: 1, //代理中心左侧tab开关
      active1: 0, //代理中心头部tab 开关

      goodsType: 0, //商品分类开关
      userShopName: '', // 商城店铺名称
      searchInfo: null, // 搜索信息
      name: null,
      goods: [],
      category: [],
      categoryId: null, //样式二  商品分类id
      imglist: [],
      set_base: {},
      categoryname: [], // 左侧导航分类名
      cate_id: '',
      status: 1, //商品管理参数
      goods: [], // 每个导航分类里面包含的商品
      choosefl: -1, // 当前导航选中状态，默认为-1
      merchantInfo: {}, // 商家店铺信息
      loadingInstance: null, // loading
      shorturl: null, // 二维码短链接
      member_apply_data: null, // 客服信息
      urlQueryName: null, // url中的 sup 或者 mid
      timer: null, // 公告定时器
      isShowMerchant: {
        // 是否显示商家信息
        info: false,
        qrcode: false,
      },
      columns: [
        { title: 'Dessert (100g serving)', width: 200, name: 'name' },
        {
          title: 'Calories',
          name: 'calories',
          width: 126,
          align: 'center',
        },
        {
          title: 'Fat (g)',
          name: 'fat',
          width: 126,
          align: 'center',
        },
        {
          title: 'Carbs (g)',
          name: 'carbs',
          width: 126,
          align: 'center',
        },
        {
          title: 'Protein (g)',
          name: 'protein',
          width: 126,
          align: 'center',
        },
        {
          title: 'Iron (%)',
          name: 'iron',
          width: 126,
          align: 'center',
        },
      ],
      list: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: 1,
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: 1,
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: 7,
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: 8,
        },
        {
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: 16,
        },
        {
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: 0,
        },
        {
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: 2,
        },
        {
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: 45,
        },
        {
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: 22,
        },
        {
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: 6,
        },
      ],

      // 订单查询
      orderColumns: [
        {
          title: '商品名称',
          width: 170,
        },
        {
          title: '订单号',
          width: 170,
        },
        {
          title: '单价',
          width: 80,
          align: 'center',
        },
        {
          title: '数量',
          width: 80,
          align: 'center',
        },
        {
          title: '操作',
          width: 100,
          align: 'center',
        },
        {
          title: '类型',
          width: 100,
          align: 'center',
        },
        {
          title: '实付款',
          width: 80,
          align: 'center',
        },
        {
          title: '交易状态',
          width: 100,
          align: 'center',
        },
        {
          title: '操作',
          width: 130,
          align: 'center',
        },
      ],
      orderList: [],
      orderCurrent: 1,
      orderTotal: null,
      // 商品管理
      goodsColumns: [
        {
          title: '商品名称',
          width: 170,
        },
        {
          title: '单价',
          width: 100,
          align: 'center',
        },
        {
          title: '利润',
          width: 100,
          align: 'center',
        },
        {
          title: '操作',
          width: 100,
          align: 'center',
        },
      ],
      // 仓库中商品
      allGoodsColumns: [
        {
          title: '商品名称',
          width: 170,
        },
        {
          title: '单价',
          width: 100,
          align: 'center',
        },
        {
          title: '操作',
          width: 100,
          align: 'center',
        },
      ],
      goodsList: [],
      allGoodsList: [],
      goodsActive: 0,
      openAllGoods: false, //仓库 一键上架弹窗
      openGoods: false, //单个商品上架/下架弹窗
      openGoodsDelete: false, //单个商品删除弹窗
      openGoodsEdit: false, //商品编辑弹窗
      openGoodsStore: false, //仓库中 上架
      openGoodsId: null,
      goodsDialgoForm: {
        type: 'default',
        menoyType: 'fixed',
        input: '',
      },
      goodsEditForm: {
        agent_price: '',
        profit: 0,
        goods_price: '',
        sort: 0,
      },
      dialogTab: 1,

      // 订单列表
      orderAwardColumns: [
        {
          title: '商品名称',
          width: 250,
        },
        {
          title: '订单编号',
          width: 200,
          align: 'center',
        },
        {
          title: '下单时间',
          width: 170,
          align: 'center',
        },
        {
          title: '订单类型',
          width: 100,
          align: 'center',
        },
        {
          title: '订单金额',
          width: 100,
          align: 'center',
        },
        {
          title: '订单状态',
          width: 100,
          align: 'center',
        },
      ],
      orderAwardList: [],
      orderAwardPage: 1,
      orderAwardTotal: 0,
      orderActive: null,
      // 佣金提现
      withdrawInfo: {},
      // 提现记录
      withdrawInput: false,
      withdrawInput2: false,
      withdrawColumns: [
        {
          title: '提现方式',
          width: 170,
        },
        {
          title: '申请提现时间',
          width: 100,
          align: 'center',
        },
        {
          title: '提现金额',
          width: 100,
          align: 'center',
        },
      ],
      withdrawRecord: [],
      withdrawStatus: 0,
      withdrawTotal: 0,
      withdrawPage: 1,
      // 店长设置
      settingInfo: {},
      uploadSrc: '',
      managerName: '', //店长设置 tab上 显示的文字
      // limit: 1,
      // 公告
      noticeList: [],
      noticeColumns: [
        {
          title: '简介',
          width: 170,
        },
        {
          title: '时间',
          width: 100,
        },
      ],
      noticePage: 1,
      userInfo: {},
      // 开店
      validateForm: {
        name: '',
        mobile: '',
        wechatid: '',
        code: '',
        paytype: '',
      },
      // 支付弹窗
      payDialog: false,
      payTime: null, //定时器
      ordersn: null,
      // 申请api状态
      apiStatus: 0,
      apiInfo: {},

      form: {
        input: '',
        input2: '',
        input3: '',
        radio: '',
        radio2: '',
        radio3: '',
      },
    }
  },
  props: {
    prop: {
      type: String,
      required: false,
    },
  },
  components: {
    HeaderTop,
    Search,
    ShopList,
    ShopList2,
    MerchantInfo,
    AccountDetails,
  },
  computed: {
    newGoods() {
      // 为-1 说明没有选中左侧导航
      if (this.choosefl === -1) {
        // 默认全部渲染
        if (this.searchInfo === null) {
          return this.category.map((item, index) => {
            return item.goods.filter((goods, idx) => {
              return goods
            })
          })
        } else {
          // 根据搜索的内容渲染
          return this.category.map((item, index) => {
            return item.goods.filter((goods, idx) => {
              return goods.title.trim().includes(this.searchInfo.trim())
            })
          })
        }
        // 这里说明点击左侧导航
      } else {
        // 宣布渲染
        if (this.searchInfo === null) {
          return this.category[this.choosefl].goods.filter((item) => {
            return item
          })
        } else {
          // 根据搜索的内容渲染
          return this.category[this.choosefl].goods.filter((item) => {
            return ([][0] = item.title.trim().includes(this.searchInfo.trim()))
          })
        }
      }
    },
    newCategoryname() {
      return this.categoryname.filter((item, index) => {
        return Number(item.classification_state) === 1
      })
    },
    uploadImgStyle() {
      let src = this.settingInfo.custormer
      if (src !== undefined) {
        if (src.indexOf('http') == -1) {
          return true
        } else {
          return false
        }
      }
    },
  },
  watch: {
    search_ipt(newVal, oldVal) {
      this.$emit('watchItp', newVal)
    },
    dlState(newVal, oldVal) {
      if (newVal == 1) {
        loading(this, 'start')
        this.getGoodsAdmin(this.status)
      } else if (newVal == 2) {
        loading(this, 'start')
        this.getOrderAwardInfo()
      } else if (newVal == 3) {
        loading(this, 'start')
        this.getWithdrawInfo()
      } else if (newVal == 4) {
        loading(this, 'start')
        this.getWithdrawRecord()
      } else if (newVal == 5) {
        loading(this, 'start')
        this.getSettingInfo()
      } else if (newVal == 6) {
        loading(this, 'start')
        this.getNotice()
      }
    },
    tab(newVal, oldVal) {
      if (newVal == 1) {
        this.orderInit()
      } else if (newVal == 2) {
        loading(this, 'start')
        this.getManagerInfo()
        this.getGoodsAdmin(this.status)
      } else if (newVal == 3) {
        loading(this, 'start')
        this.getApiInfo()
      }
    },
    goodsActive(newVal, oldVal) {
      if (newVal == 0) {
        loading(this, 'start')
        this.status = 1
        this.getGoodsAdmin(this.status)
      }
      if (newVal == 1) {
        loading(this, 'start')
        this.status = 0
        this.getGoodsAdmin(this.status)
      }
      if (newVal == 2) {
        loading(this, 'start')
        this.getAllGoods()
      }
    },
    'goodsEditForm.profit'(newVal, oldVal) {
      if (newVal) {
        this.goodsEditForm.goods_price =
          // (
          //   Number(newVal) +
          //   Number(this.goodsEditForm.agent_price)
          // ).toFixed(2)
          (
            Math.round(
              (Number(newVal) + Number(this.goodsEditForm.agent_price)) * 100
            ) / 100
          ).toFixed(2)
      }
    },
    openGoodsEdit(newVal, oldVal) {
      if (newVal == false) {
        this.goodsEditForm = {
          agent_price: '',
          goods_price: '',
          profit: '',
          sort: '',
        }
      }
    },
    withdrawStatus(newVal, oldVal) {
      if (newVal == 0) {
        loading(this, 'start')
        this.withdrawStatus = 0
        this.getWithdrawRecord()
      } else {
        loading(this, 'start')
        this.withdrawStatus = 1
        this.getWithdrawRecord()
      }
    },
    payDialog(newVal, oldVal) {
      if (newVal == true) {
        this.payTime = setInterval(() => {
          this.queryPayment()
        }, 1500)
      } else {
        clearInterval(this.payTime)
      }
    },
  },
  methods: {
    watchItp(e) {
      this.searchInfo = e
    },
    // 隐藏显示订单详情子组件
    //vet: function () {
    //this.show = !this.show
    //},
    // 初始化 获取商品
    async initData(keyword = '') {
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid

      let res = await getData.getShopData(
        name,
        this.$route.query[name],
        keyword
      )
      let banner = res.banner

      // 储存图片
      this.imglist = []
      banner.map((item) => {
        this.imglist.push(item.thumb)
      })

      this.set_base = res.set_base
      this.style = res.set_base.shopPC_style || 0
      this.category = res.category
      this.categoryname = res.category
      this.name = res.name
      this.getShopInfo()

      const category = res.category
      //带分类
      if (res.set_base.cate_order) {
        if (this.cate_id != '') {
          for (var i in category) {
            this.category[i].goods = []
            if (category[i].id == this.cate_id) {
              for (var j in res.goods[this.cate_id]) {
                this.category[i].goods.push(res.goods[this.cate_id][j])
              }
            }
          }
        } else
          for (var i in category) {
            this.category[i].goods = []
            for (var j in res.goods) {
              for (var k in res.goods[j]) {
                if (res.goods[j][k].cate_id == category[i].id) {
                  this.category[i].goods.push(res.goods[j][k])
                }
              }
            }
          }
      }
      //未分类
      else {
        if (this.cate_id != '') {
          var goods = []
          for (var i in res.goods) {
            if (res.goods[i].cate_id == this.cate_id) {
              goods.push(res.goods[i])
            }
          }
          this.goods = goods
        } else this.goods = res.goods
      }
      loading(this, 'close')
    },
    // 搜索
    searchClick() {
      this.tab = 0
      loading(this, 'start')
      if (
        this.search_ipt == ' ' ||
        this.search_ipt == null ||
        this.search_ipt == undefined
      ) {
        return
      } else {
        this.initData(this.search_ipt)
      }
    },
    // 获取商品管理
    async getGoodsAdmin(status) {
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid

      let res = await getData.getGoodsAdmin(
        name,
        this.$route.query[name],
        status
      )
      if (res.error == 0) {
        this.goodsList = res.shop_goods
      } else if (res.error == -2) {
        this.$route.meta.keepAlive = false
        this.$router.replace({
          path: '/pc/login',
          query: {
            [name]: this.$route.query[name],
            style: 3,
          },
        })
      }
      loading(this, 'close')
    },
    // 获取仓库中商品
    async getAllGoods() {
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid

      let res = await getData.getAllGoods(name, this.$route.query[name])
      if (res.error == 0) {
        this.allGoodsList = res.list
      } else if (res.error == -2) {
        this.$route.meta.keepAlive = false
        this.$router.replace({
          path: '/pc/login',
          query: {
            [name]: this.$route.query[name],
            style: 3,
          },
        })
      }
      loading(this, 'close')
    },
    // 一键下架
    async allGoodsOut() {
      if (this.goodsList.length == 0) {
        this.$message({
          showClose: true,
          message: '暂无出售中的商品',
          type: 'error',
        })
        return
      }
      loading(this, 'start')
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid
      let data = {
        status: 0,
        id: [],
      }
      this.goodsList.map((item) => {
        data.id.push(item.id)
        return data
      })
      let res = await getData.allGoodsDown(name, this.$route.query[name], data)
      if (res.error == 0) {
        this.$message({
          showClose: true,
          message: res.message,
          type: 'success',
        })
        this.getGoodsAdmin(this.status)
      }
      loading(this, 'close')
    },
    // 一键删除
    async allGoodsDelete() {
      if (this.goodsList.length == 0) {
        this.$message({
          showClose: true,
          message: '暂无下架的商品',
          type: 'error',
        })
        return
      }
      loading(this, 'start')
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid
      let data = []
      this.goodsList.map((item) => {
        data.push(item.id)
        return data
      })
      let res = await getData.allGoodsDelete(
        name,
        this.$route.query[name],
        data
      )
      if (res.error == 0) {
        this.$message({
          showClose: true,
          message: res.message,
          type: 'success',
        })
        this.status = 0
        this.getGoodsAdmin(this.status)
      }
      loading(this, 'close')
    },
    // 单个商品删除
    goodsDelete(id) {
      this.openGoodsId = id
      this.openGoodsDelete = true
    },
    //单个商品删除弹窗确定
    async openGoodsDeleteSure() {
      let data = {
        id: this.openGoodsId,
      }
      loading(this, 'start')
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid
      let res = await getData.goodsDelete(name, this.$route.query[name], data)
      if (res.error == 0) {
        this.openGoodsDelete = false
        this.$message({
          showClose: true,
          message: res.message,
          type: 'success',
        })
        this.status =
          this.goodsActive == 0 ? 1 : this.goodsActive == 1 ? 0 : null
        this.getGoodsAdmin(this.status)
      }
    },
    // 一键上架
    allGoodsPataway() {
      this.openAllGoods = true
    },
    // 单个商品下架/下架
    goodsOperation(id) {
      this.openGoodsId = id
      this.openGoods = true
    },
    // 一键上架弹窗确认
    async goodsDialogSure() {
      this.openAllGoods = false
      let data = this.allGoodsList
        .filter((item) => {
          return item.memberGoods == null
        })
        .map((item) => {
          return {
            id: item.id,
            agent_price: item.agent_price,
            goods_price: item.goods_price,
            status: 1,
            sort: 0,
            profit:
              this.dialogTab == 1
                ? 0
                : this.dialogTab == 2 &&
                  this.goodsDialgoForm.menoyType == 'fixed'
                ? this.goodsDialgoForm.input
                : this.dialogTab == 2 &&
                  this.goodsDialgoForm.menoyType == 'percent'
                ? Number((item.goods_price * this.goodsDialgoForm.input) / 100)
                : 0,
            add: false,
          }
        })
      if (data.length == 0) {
        this.$message({
          showClose: true,
          message: '暂无可上架的商品',
          type: 'error',
        })
        return
      }
      loading(this, 'start')
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid
      let res = await getData.allGoodsPataway(
        name,
        this.$route.query[name],
        data
      )
      if (res.error == 0) {
        this.$message({
          showClose: true,
          message: res.message,
          type: 'success',
        })
        this.getAllGoods()
      }
    },
    // 单个商品上架/下架弹窗确定
    async openGoodsSure() {
      let data = {
        id: this.openGoodsId,
        status: this.goodsActive == 0 ? 0 : this.goodsActive == 1 ? 1 : null,
      }
      loading(this, 'start')
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid
      let res = await getData.goodsDown(name, this.$route.query[name], data)
      if (res.error == 0) {
        this.openGoods = false
        this.$message({
          showClose: true,
          message: res.message,
          type: 'success',
        })
        this.status =
          this.goodsActive == 0 ? 1 : this.goodsActive == 1 ? 0 : null
        this.getGoodsAdmin(this.status)
      }
    },
    // 仓库中 单个商品上架
    goodsPataway(row) {
      this.openGoodsStore = true
      this.openGoodsId = row.id
      this.goodsEditForm.agent_price = row.agent_price
      this.goodsEditForm.goods_price = Number(row.agent_price)
    },
    // 仓库中  单个商品上架弹窗确定
    async openGoodsStoreSure() {
      let data = {
        id: this.openGoodsId,
        agent_price: this.goodsEditForm.agent_price,
        goods_price: this.goodsEditForm.goods_price,
        profit: this.goodsEditForm.profit,
        sort: this.goodsEditForm.sort,
        add: false,
        status: 1,
      }
      loading(this, 'start')
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid
      let res = await getData.goodsPataway(name, this.$route.query[name], data)
      if (res.error == 0) {
        this.openGoodsStore = false
        this.$message({
          showClose: true,
          message: res.message,
          type: 'success',
        })
        this.getAllGoods()
      }
    },
    // 商品编辑
    goodsEdit(row) {
      this.openGoodsEdit = true
      this.openGoodsId = row.id
      this.goodsEditForm.agent_price = row.agent_price
      this.goodsEditForm.goods_price = Number(row.agent_price)
    },
    // 商品编辑弹窗确定
    async openGoodsEditSure() {
      let data = {
        id: this.openGoodsId,
        agent_price: this.goodsEditForm.agent_price,
        goods_price: this.goodsEditForm.goods_price,
        profit: this.goodsEditForm.profit,
        sort: this.goodsEditForm.sort,
        add: false,
        status: 1,
      }
      loading(this, 'start')
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid
      let res = await getData.goodsEdit(name, this.$route.query[name], data)
      if (res.error == 0) {
        this.openGoodsEdit = false
        this.$message({
          showClose: true,
          message: res.message,
          type: 'success',
        })
        this.status =
          this.goodsActive == 0 ? 1 : this.goodsActive == 1 ? 0 : null
        this.getGoodsAdmin(this.status)
      }
    },
    // 获取订单奖励信息
    async getOrderAwardInfo() {
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid

      let res = await getData.getOrder(
        name,
        this.$route.query[name],
        this.orderAwardPage
      )
      if (res.error == 0) {
        this.orderAwardList = res.list.filter((item) => {
          return item.order_divide !== null
        })
        this.orderAwardTotal = res.total
      } else if (res.error == -2) {
        this.$route.meta.keepAlive = false
        this.$router.replace({
          path: '/pc/login',
          query: {
            [name]: this.$route.query[name],
            style: 3,
          },
        })
      }
      loading(this, 'close')
    },
    // 订单奖励分页
    orderAwardChange(e) {
      loading(this, 'start')
      this.orderAwardPage = e
      this.getOrderAwardInfo()
    },
    // 获取提现信息
    async getWithdrawInfo() {
      let name = getUrlUserInfo(this.$route.fullPath)
      let res = await getData.getWithdrawInfo(name, this.$route.query[name])
      if (res.error == 0) {
        this.withdrawInfo = res
        if (res.name == '') {
          this.withdrawInput = true
        }
        if (res.alipay_no == '') {
          this.withdrawInput2 = true
        }
      } else if (res.error == -2) {
        this.$route.meta.keepAlive = false
        this.$router.replace({
          path: '/pc/login',
          query: {
            [name]: this.$route.query[name],
            style: 3,
          },
        })
      }
      loading(this, 'close')
    },
    // 提现
    async postWithdrawInfo() {
      loading(this, 'start')
      let name = getUrlUserInfo(this.$route.fullPath)
      let data = {
        name: this.withdrawInfo.name,
        alipay_no: this.withdrawInfo.alipay_no,
      }
      let res = await getData.postWithdrawInfo(
        name,
        this.$route.query[name],
        data
      )
      if (res.error == 0) {
        this.$message({
          showClose: true,
          message: res.message,
          type: 'success',
        })
      } else {
        this.$message({
          showClose: true,
          message: res.message,
          type: 'error',
        })
      }
      loading(this, 'close')
    },
    // 获取提现记录
    async getWithdrawRecord() {
      let name = getUrlUserInfo(this.$route.fullPath)
      let res = await getData.getWithdrawRecord(
        name,
        this.$route.query[name],
        this.withdrawStatus
      )
      if (res.error == 0) {
        this.withdrawRecord = res.list
        this.withdrawTotal = res.total
      } else if (res.error == -2) {
        this.$route.meta.keepAlive = false
        this.$router.replace({
          path: '/pc/login',
          query: {
            [name]: this.$route.query[name],
            style: 3,
          },
        })
      }
      loading(this, 'close')
    },
    // 提现分页
    withdrawChange(e) {
      this.withdrawPage = e
      this.getWithdrawRecord()
    },
    // 获取店长设置
    async getSettingInfo() {
      let name = getUrlUserInfo(this.$route.fullPath)
      let res = await getData.getSettingInfo(name, this.$route.query[name])
      if (res.error == 0) {
        this.settingInfo = JSON.parse(res.apply_data)
        if (this.settingInfo.custormer == null) {
          this.settingInfo.custormer =
            'image/2020/07/1e7b0e8c38d1a27520ca97f1433a1a81.png'
        }
        if (this.settingInfo.close_agent == null) {
          this.settingInfo.close_agent = '0'
        }
        if (this.settingInfo.close_notice == null) {
          this.settingInfo.close_notice = '0'
        }
        if (this.settingInfo.close_group == null) {
          this.settingInfo.close_group = '0'
        }
      } else if (res.error == -2) {
        this.$route.meta.keepAlive = false
        this.$router.replace({
          path: '/pc/login',
          query: {
            [name]: this.$route.query[name],
            style: 3,
          },
        })
      }
      loading(this, 'close')
    },
    uploadChange(file, fileList) {
      console.log(file, fileList)
    },
    // 上传图片
    async uploadRequest(params) {
      const file = params.file,
        fileType = file.type,
        isImage = fileType.indexOf('image') != -1,
        isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      if (!isImage) {
        this.$message({
          showClose: true,
          message: '只能上传图片格式png、jpg、gif!',
          type: 'error',
        })
        return
      }
      if (!isLt2M) {
        this.$message({
          showClose: true,
          message: '只能上传图片大小小于2M',
          type: 'error',
        })
        return
      }
      let name = getUrlUserInfo(this.$route.fullPath)
      const form = new FormData()
      form.append('file', file)
      let res = await getData.upload(name, this.$route.query[name], form)
      if (res.error == 0) {
        this.$message({
          showClose: true,
          message: '图片切换成功',
          type: 'success',
        })
        this.settingInfo.custormer = res.path
      } else {
        this.$message({
          showClose: true,
          message: res.message,
          type: 'error',
        })
      }
    },
    // 保存设置
    async setSetting() {
      loading(this, 'start')
      let name = getUrlUserInfo(this.$route.fullPath)
      let res = await getData.setSetting(
        name,
        this.$route.query[name],
        this.settingInfo
      )
      if (res.error == 0) {
        this.$message({
          showClose: true,
          message: '保存成功',
          type: 'success',
        })
      } else {
        this.$message({
          showClose: true,
          message: res.error,
          type: 'error',
        })
      }
      loading(this, 'close')
    },
    // 获取公告
    async getNotice() {
      let name = getUrlUserInfo(this.$route.fullPath)
      let res = await getData.getNotice(
        name,
        this.$route.query[name],
        this.noticePage
      )
      if (res.error == 0) {
        console.log(res)
        this.noticeList = res.list
      } else if (res.error == -2) {
        this.$route.meta.keepAlive = false
        this.$router.replace({
          path: '/pc/login',
          query: {
            [name]: this.$route.query[name],
            style: 3,
          },
        })
      }
      loading(this, 'close')
    },
    // 设置标题title
    setTitle(res) {
      if (!res) return
      this.userShopName = res.name

      document.title = res.name
    },
    // increment() {
    //   this.$store.commit('increment')
    // },
    classification(id, idx) {
      if (this.choosefl === idx) return
      loading(this, 'start')
      this.cate_id = id
      this.choosefl = idx
      this.initData()
    },
    // 获取店铺个人信息
    async getShopInfo() {
      let name = getUrlUserInfo(this.$route.fullPath)
      this.urlQueryName = name
      let shop = await getData.getShopInfo(name, this.$route.query[name])
      if (this.style == 0) {
        this.merchantInfo = shop.sup_user
        this.$core.qrcode('qrcode', this.merchantInfo.shorturl)
      }

      if (shop && shop.sup_user) {
        this.setTitle(shop.sup_user)
      }
    },
    // 点击 获取全部商品
    selectAllGoods() {
      if (this.choosefl === -1) return
      loading(this, 'start')
      this.choosefl = -1

      this.cate_id = ''
      this.initData()
    },
    // 公告定时器
    setAnimate() {
      var scrollarea = document.getElementById('scrollarea')
      if (!scrollarea) return
      var scrolltext = scrollarea.children[0]
      var left = parseInt(scrolltext.style.marginLeft)
      var width = scrolltext.offsetWidth
      if (!left) left = 0
      if (-left <= width) {
        scrolltext.style.marginLeft = left - 1 + 'px'
      } else {
        var child = scrolltext.cloneNode(true)
        child.style.marginLeft = 0
        scrollarea.appendChild(child)
        scrollarea.removeChild(scrollarea.firstChild)
      }
    },
    //tab
    tabClick(e) {
      this.tab = e
      loading(this, 'start')
      setTimeout(() => {
        loading(this, 'close')
      }, 500)
    },
    // 代理中心tab
    dlClick(e) {
      this.dlState = e
      loading(this, 'start')
      setTimeout(() => {
        loading(this, 'close')
      }, 500)
    },
    // 代理中心头部tab
    handleClick(tab, event) {},
    // 商品分类
    goodsClick(index, item) {
      loading(this, 'start')
      setTimeout(() => {
        if (item) {
          this.categoryId = item.id
        } else {
          this.categoryId = null
        }
        this.goodsType = index
        loading(this, 'close')
      }, 500)
    },
    // 获取订单信息
    async orderInit(i = null) {
      loading(this, 'start')
      let data = {
        status: i,
        page: this.orderCurrent,
      }
      let name = await getUrlUserInfo(this.$route.fullPath)
      let res = await Order.getOrder(name, this.$route.query[name], data)

      if (res.error === 0) {
        loading(this, 'close')
        this.orderList = []
        this.orderTotal = res.total
        res.list.map((item, index) => {
          let data = {
            id: item.id,
            title: item.goods[0].title,
            ordersn: item.ordersn,
            price: item.goods[0].price,
            num: item.goods[0].num,
            type_text: item.type_text,
            type:
              item.type == 0
                ? '卡密商品'
                : item.type == 1
                ? '虚拟商品'
                : item.type == 2
                ? '实体商品'
                : item.type == 3
                ? '市场商品'
                : item.type == 4
                ? '官方卡密商品'
                : item.type == 5
                ? '官方代充商品'
                : '',
            actual_price: item.price,
            statusstr: item.statusstr,
          }

          this.orderList.push(data)
          return this.orderList
        })
      } else if (res.error === -2) {
        this.$route.meta.keepAlive = false
        this.$router.replace({
          path: '/pc/login',
          query: {
            [name]: this.$route.query[name],
            style: 1,
          },
        })
      } else {
        Message(this, `订单获取失败，请重试`, 'error')
      }
    },
    // 订单分页
    orderChange(e) {
      console.log(e)
      this.orderCurrent = e
      this.orderInit(this.orderActive)
    },
    tabOrder(i = null) {
      this.orderActive = i
      this.orderInit(i)
    },
    // 订单详情
    detailsClick(id) {
      this.$route.meta.keepAlive = true
      this.$router.push({
        path: '/pc/detail',
        query: {
          [this.urlQueryName]: this.$route.query[this.urlQueryName],
          orderid: id,
        },
      })
    },
    // 登录
    async loginClick() {
      let name = await getUrlUserInfo(this.$route.fullPath)
      this.$route.meta.keepAlive = false
      this.$router.push({
        path: '/pc/login',
        query: {
          [name]: this.$route.query[name],
          style: 2,
        },
      })
    },
    async loginOut() {
      let name = await getUrlUserInfo(this.$route.fullPath)
      let res = await login.loginOut(name, this.$route.query[name])
      if (res.error == 0) {
        this.name = null
        this.tab = 0
        this.$message({
          showClose: true,
          message: '退出成功',
          type: 'success',
        })
      } else {
        this.$message({
          showClose: true,
          message: res.message,
          type: 'error',
        })
      }
    },
    // 获取店长信息
    async getManagerInfo() {
      let name = await getUrlUserInfo(this.$route.fullPath)
      let res = await getData.getManagerInfo(name, this.$route.query[name])
      if (res.error == 0) {
        this.managerName = res.text.agent
        this.userInfo = res.user
        this.validateForm.name = res.user.name
        this.validateForm.mobile = res.user.mobile
      }
    },
    // 开店缴费
    async openShopSubmit() {
      let name = await getUrlUserInfo(this.$route.fullPath)
      this.validateForm.wechatid = this.validateForm.mobile
      let res = await getData.openShopSubmit(
        name,
        this.$route.query[name],
        this.validateForm
      )
      if (res.error == 0) {
        this.payDialog = true
        // console.log(res.pay_info)
        this.$nextTick(() => {
          this.$core.qrcode('payQrcode', res.pay_info)
          this.ordersn = res.ordersn
          // let qrcode = document.getElementById('payQrcode')
          // console.log(qrcode)
        })
      } else {
        this.$message({
          showClose: true,
          message: res.message,
          type: 'error',
        })
      }
    },
    // 查询支付状态
    async queryPayment() {
      let name = await getUrlUserInfo(this.$route.fullPath)
      let data = {
        ordersn: this.ordersn,
      }
      let res = await getData.queryPayment(name, this.$route.query[name], data)
      if (res.error == 0) {
        this.payDialog = false
        this.$message({
          showClose: true,
          message: res.message,
          type: 'success',
        })
        clearInterval(this.payTime)
      }
    },
    // 获取api信息
    async getApiInfo() {
      let name = await getUrlUserInfo(this.$route.fullPath)
      let res = await getData.getApiInfo(name, this.$route.query[name])
      if (res.error == 0) {
        this.apiInfo = res.result.info
        if (this.apiInfo.level == 1) {
          this.apiInfo.level = '普通代理'
        } else if (this.apiInfo.level == 2) {
          this.apiInfo.level = '钻石代理'
        } else if (this.apiInfo.level == 3) {
          this.apiInfo.level = '至尊会员'
        }
      } else if (res.error == -2) {
        this.$route.meta.keepAlive = false
        this.$router.replace({
          path: '/pc/login',
          query: {
            [name]: this.$route.query[name],
            style: 4,
          },
        })
      }
      loading(this, 'close')
    },
    // 申请api
    async applyApi() {
      let name = await getUrlUserInfo(this.$route.fullPath)
      let res = await getData.applyApi(name, this.$route.query[name])
      if (res.error == 0) {
        this.$message({
          showClose: true,
          message: res.message,
          type: 'success',
        })
        loading(this, 'start')
        this.getApiInfo()
      }
    },
    // 复制appid
    copyAppid(data) {
      var input = document.createElement('input') // 直接构建input
      input.value = data // 设置内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand('Copy') // 执行复制
      document.body.removeChild(input) // 删除临时实例
    },
    // 复制appkey
    copyAppkey(data) {
      var input = document.createElement('input') // 直接构建input
      input.value = data // 设置内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand('Copy') // 执行复制
      document.body.removeChild(input) // 删除临时实例
    },
  },
  async created() {
    // 如果为手机端访问，则跳转到对应的手机端页面
    const name = await getUrlUserInfo(this.$route.fullPath)
    if (isMobile()) {
      window.location = `https://app.weilian.xin/m/index?${name}=${this.$route.query[name]}`
    }
    loading(this, 'start')
    this.timer = setInterval(this.setAnimate, 25)
    if (localStorage.getItem('tab')) {
      this.tab = localStorage.getItem('tab')
      localStorage.removeItem('tab')
    }
    // setTimeout(() => {
    //   if (loading(this, 'start')) {
    //     loading(this, 'close')
    //     Message(this, `连接超时，请重试`, 'error')
    //   }
    // }, 6000)
    // if (!this.$route.query.sup) {
    //   window.location.href = window.location.href + '?sup=PBneG9rm7Lv2Nm0J'
    // }
  },
  //获取账户余额

  mounted() {
    this.initData()
  },
  updated() {},
  destroyed() {
    loading(this, 'close')
    clearInterval(this.timer)
    this.timer = null
  },
  filters: {},
}
</script>

<style scoped lang="less">
@import '../../../common/Less/index.less';
.container_Search {
  .mixin_flex_ct();
  .mixin_wh(630px, 40px);
  position: relative;
  justify-content: space-between;
  border: 2px solid #ffa662;
  border-radius: 20px;

  .left {
    .mixin_flex_ct();
    justify-content: left;
    flex: 1;
    .icon_search {
      margin: 8px 0 10px 26px;
    }
    .search_ipt {
      .mixin_wh(50%, 14px);

      border: none;
      outline: none;
      font-size: @fontSize - 2;
      font-weight: 400;
      margin-left: 25px;
      letter-spacing: 3px;
    }
  }
  .right {
    > button {
      .mixin_absolute(0, -3px, '', '');
      .mixin_wh(116px, 36px);
      .mixin_cb(@white, #ffa662);
      outline: none;
      border: none;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
    }
  }
}
.container {
  // width: 1020px;
  width: 1280px;
  margin: 0 auto;
  .title {
    .mixin_flex_ct();
    justify-content: space-between;

    margin: 0 0 6px 0;
    height: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 18px;

    padding: 0 15px 0 0px;

    .title_name {
      font-size: @fontSize;
      letter-spacing: @spacing;
      .mx_flex(row; nowrap; flex-start; center);
      span {
        margin-left: 5px;
      }
    }
    .title_signin {
      font-size: @fontSize -1;
      .mx_flex(row; nowrap; center; baseline);

      .merchant_parent {
        position: relative;
        margin-left: 11px;
        cursor: pointer;
        span {
          color: #909399;
        }
        .merchant_info {
          .mx_absolute(130%; 10%; '' ; '');
          z-index: 1000;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }
      }
    }
    .title_signin span:nth-child(2) {
      .mixin_wh(55px, 14px);
      opacity: 0.8;
      a {
        text-decoration: none;
        color: @blue !important;
      }
    }
    .title_signin span:nth-child(2) {
      .mixin_wh(60px, 15px);
      opacity: 0.8;
    }
  }
  .search {
    margin-top: 22px;
    // margin-left: 248px;
  }
  .leadnews {
    height: 27px;
    padding: 6px;
    margin: 10px auto;
    width: 624px;
    align-items: center;
    .trumpet {
      position: relative;
      .icon {
        .mx_flex();
      }
    }
    img {
      height: 70%;
      width: auto;
      padding-right: 10px;
      border-right: 1px solid #e2e2e2;
    }

    > div {
      font-size: 12px;
      margin-left: 4px;
      overflow: hidden;

      .text {
        padding-right: 20px;
        white-space: nowrap;
      }
    }
  }
  .content {
    .mixin_flex(row, no-wrap, center, '');
    .mixin_wh('', 650px);
    background: #f7faff;
    margin-top: 17px;
    margin-bottom: 70px;
    padding-top: 14px;

    position: relative;
    nav {
      // .mixin_wh('', 346px);
      min-width: 167px;
      max-width: 230px;
      width: 146px;
      .mixin_cb(@black, #e0f2ff);
      font-size: @fontSize - 2;
      letter-spacing: @spacing;
      overflow-y: auto;
      .allGoods {
        margin: 0;
        padding: 0;
        li {
          list-style: none;
          padding: 10px;

          .mixin_flex(row, wrap, flex-start, '');
          cursor: pointer;
          span {
            margin-left: 10px;
          }
        }
        &_img {
          .mixin_square(22px);
        }
      }
      .nav_ul {
        margin: 0;
        padding: 0;
        .nav_li {
          .mixin_flex(row, nowrap, flex-start, center);
          list-style: none;
          cursor: pointer;
          // line-height: 13px;
          // text-align: justify;
          // word-break: break-all;

          div {
            margin: 10px;
            img {
              .mixin_square(35px);
            }
          }
          span {
            margin: 10px 10px 10px 0;
            display: inline-block;
            white-space: nowrap;
            width: 100%;
            overflow: hidden;
            // text-overflow: ellipsis;
          }
        }
      }
      .nav_ul_active {
        .mixin_cb(@white, @blue);
      }
    }
    .footer {
      .mx_absolute('' ; '' ; -60px; 50%);
      transform: translateX(-50%);
    }
  }
}

header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 30px;
  align-items: center;
  margin-top: 15px;
  .search {
    margin-top: 0 !important;
  }
  .merchant_info {
    position: absolute;
    z-index: 100;
  }
  .login_out {
    display: none;
  }
  .login {
    display: block;
  }
  .login_box {
    display: inline-block;
    width: 85px;
  }
  .login_box:hover .login_out {
    display: block;
  }
  .login_box:hover .login {
    display: none;
  }
}
.tab {
  display: flex;
  width: 100%;
  background: #f7f7f7;
  padding: 0 30px;
  margin-top: 10px;
  > div {
    height: 50px;
    line-height: 50px;
    margin-right: 20px;
    cursor: pointer;
  }
  > i {
    width: 1px;
    height: 20px;
    margin: auto 0;
    margin-right: 20px;
    background-color: #d9d9d9;
  }
  .tab-pitch {
    color: #f04e00;
    border-bottom: 2px solid #f04e00;
  }
}
.style {
  .goods-tab {
    background-color: #fff;
    padding-right: 20px;
    padding-bottom: 15px;
    display: flex;
    > div {
      padding: 10px 30px;
      cursor: pointer;
    }
    .goods-type {
      font-size: 14px;
      color: #000;
    }
    .type-pitch {
      background-color: #ffe4dc;
      .goods-type {
        color: #ff5000;
      }
    }
  }
}
.style1 {
  /deep/ .container {
    width: 100%;
  }
  /deep/ .mu-table-header {
    width: 100% !important;
  }
  /deep/ .mu-table-body {
    width: 100% !important;
  }
  /deep/ .mu-table-body-wrapper::-webkit-scrollbar {
    width: 0 !important;
  }
  .tab_order {
    width: 100px;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
  }
  .order-active {
    background: #fff;
  }
}
.style3 {
  display: flex;
  margin-top: 0 !important;
  .style3-left {
    width: 150px;
    text-align: center;
    dl {
      background: #fff;
      height: 100%;
      width: 100%;
      margin: 0;
      > dt,
      dd {
        line-height: 50px;
      }
      dt {
        margin-left: -40px;
      }
      dd {
        margin: 0;
        cursor: pointer;
      }
      .dl-active {
        background-color: #ffe4dc;
        color: #ff5000;
      }
    }
  }
  .style3-right {
    flex: 1;
    height: 100%;
    margin-left: 4px;
    .style3-tab {
      background: #fff;
      position: relative;
      /deep/ .mu-button {
        position: absolute;
        right: 20px;
      }
    }
    /deep/ .mu-tabs-inverse {
      background: #fff;
    }
    /deep/ .container {
      margin: 10px auto;
      width: 100%;
    }
    /deep/ .mu-table-header {
      width: 100% !important;
    }
    /deep/ .mu-table-body {
      width: 100% !important;
    }
    .echarts {
      background: #fff;
      width: 100%;
      height: 445px;
      padding: 20px;
      .echarts-title {
        font-size: 24px;
        text-align: center;
      }
      .pay-init {
        width: 80%;
        height: 40px;
        line-height: 40px;
        color: #000;
        margin: 20px auto;
        background: #e3f0fd;
        display: flex;
        justify-content: space-around;
      }
      /deep/ .mu-raised-button.mu-button-full-width {
        width: 20%;
        margin: auto;
        display: block;
      }
      .pay-style {
        display: block;
        background: red;
        height: 25px;
        width: 60px;
        text-align: center;
        line-height: 25px;
        color: #fff;
      }
    }
  }
  /deep/ .mu-table-body-wrapper::-webkit-scrollbar {
    width: 0 !important;
  }
  .settingInfo-img {
    width: 148px;
    height: 148px;
    margin-right: 20px;
  }
  .pay {
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    float: left;
    border-radius: 10px;
    cursor: pointer;
  }
  .withdraw-input {
    background: none;
    outline: none;
    border: none;
    width: 100px;
  }
  .API-box {
    margin: 20px auto;
    text-align: center;
  }
}
/deep/ .mu-radio-label {
  font-size: 14px;
}
.back-FFF {
  background-color: #fff;
  width: 100%;
}
.content-style {
  width: 100%;
  overflow-x: hidden;
  margin-top: 30px;
  //min-height: 450px;
  background-color: #f1f1f1;
}

.flex-nw,
.flex-nw-ac,
.flex-nw-jc,
.flex-nw-ajc,
.flex-nw-ajb,
.flex-nw-aja {
  display: flex;
  flex-wrap: nowrap;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/index/index.vue